import get from 'lodash/get';

import {
  CLEAR_RECIPIENTS_REQUESTED,
  GET_RECIPIENTS_SUCCESS,
} from '../actionConstants';

const defaultState = {
  count: 0,
  next: {},
  previous: {},
  results: [],
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_RECIPIENTS_SUCCESS:
      return {
        count: get(action, 'payload.data.count'),
        next: get(action, 'payload.data.next'),
        previous: get(action, 'payload.data.previous'),
        results: [...state.results, ...get(action, 'payload.data.results')],
      };
    case CLEAR_RECIPIENTS_REQUESTED:
      return defaultState;
    default:
      return state;
  }
};
